import { ReactElement, ReactNode } from 'react';
import { BlockState } from '../block/types';
import { Box, Icon } from '@ff-it/ui';
import { Tooltip } from 'react-tooltip';

const blockStateHelp: Record<BlockState, ReactNode> = {
  NEW: 'Unassigned plan',
  PLANNING: 'Assigned and in planning',
  SUBMITTED: 'Submitted for approval',
  APPROVED: 'Approved plan',
  DONE: 'Completed and executed plan',
  CANCELED: 'Canceled plan',
};

export function BlockStateHelpLabel({ children: state }: { children: BlockState }): ReactElement {
  return (
    <Box textSize="xs" color="gray500" fontWeight="semibold">
      {state} <Icon icon="circle-question" data-tooltip-id={`${state}-tooltip`} />
      <Tooltip id={`${state}-tooltip`}>{blockStateHelp[state]}</Tooltip>
    </Box>
  );
}
